export default __webpack_public_path__ + "static/media/icon-snap-your-trash.efd726df.svg";